import { render, staticRenderFns } from "./PopupOffer.vue?vue&type=template&id=04a85300&"
import script from "./PopupOffer.vue?vue&type=script&lang=js&"
export * from "./PopupOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports